import { TitleText } from 'text/part'
import { Article } from './types'

const ProfileArticle: Article = {
  title: TitleText.profile,
  rows: {
    jp: [
      ['名前', '中田 匠哉'],
      ['所属', '神戸大学大学院システム情報学研究科修士1回生'],
      ['メール', 'tnakata (at) ws.cs.kobe-u.ac.jp'],
      ['趣味', 'クラシックギター ゲーム アニメ VTuber'],
      [
        '一言',
        'サービス個人適応の研究をしています。',
      ],
    ],
    en: [
      ['Name', 'Nakata Takuya (中田 匠哉)'],
      [
        '',
        "Master's student, Graduate School of System Informatics, Kobe University",
      ],
      ['mail', 'tnakata (at) ws.cs.kobe-u.ac.jp'],
      ['hobby', 'classical guitar, game, anime, VTuber'],
      [
        'comment',
        "Researching service personal adaptation.",
      ],
    ],
  },
}

export default ProfileArticle
